import Teilimpfungen from '@/types/Teilimpfungen';
import Folgeimpfstoff from '@/types/Folgeimpfstoff';

export default class Impfstoff {
    /** PK: Impfstoff | erforderlich **/
    public impfstoff_id: number | null = null;
    /** j/n | max. 1 Zeichen | erforderlich **/
    public gueltig: string | null = 'j';
    /** Impfstoffname | max. 20 Zeichen | erforderlich **/
    public impfstoff: string | null = null;
    /** FK: ImpfstoffPZN (Id. in eImpf_Impfstoffe_VS) | max. 10 Zeichen **/
    public impfstoff_code: string | null = null;
    /** EAN-13 (13-stellig) | max. 20 Zeichen **/
    public barcode: string | null = null;
    /** Impfstoffbezeichnung | max. 100 Zeichen | erforderlich **/
    public bezeichnung: string | null = null;
    /** Impfung | max. 100 Zeichen | erforderlich **/
    public impfung: string | null = null;
    /** Hersteller | max. 100 Zeichen **/
    public hersteller: string | null = null;
    /** @deprecated Teilimpfungsanzahl | erforderlich **/
    public teilimpfungsanzahl: number | null = null;
    /** @deprecated impfschutz **/
    public impfschutz: number | null = null;
    /** @deprecated Auffrischungsintervall **/
    public auffrischungsintervall: number | null = null;
    /** Einkaufspreis **/
    public einkaufspreis: number | null = null;
    /** Verkaufspreis **/
    public verkaufspreis: number | null = null;
    /** MwSt.-Satz **/
    public steuersatz: number | null = null;
    /** j/n **/
    public impferinnerung: string | null = 'j';
    /** Mindestbestand **/
    public mindestbestand: number | null = 0;
    /** Anmerkung | max. 1073741823 Zeichen **/
    public anmerkung: string | null = null;
    /** Impferinnerungstext bei Auffrischungen | max. 1073741823 Zeichen **/
    public impferinnerungstext: string | null = null;
    /** 0=keine HCW-Impfung,1=immer HCW-Impfung, 2=mögliche HCW-Impfung */
    public hcw: string | null = null;
    /** nur MUW */
    public preis_mitarbeiter: number | null = null;
    /** nur MUW */
    public preis_rektorat: number | null = null;
    /** nur MUW */
    public rabatt_mitarbeiter: number | null = null;
    /** nur MUW */
    public aufschlag_rektorat: number | null = null;

    public teilimpfungen: Teilimpfungen[] = [];
    public folgeimpfstoffe: Folgeimpfstoff[] = [];
    public lagerbestand: string | null = null;
    public aufschlagRektorat: number | null = null;
    public rabattMitarbeiter: number | null = null;

    constructor(data?: Partial<Impfstoff>) {
        Object.assign(this, data);

        if (this.aufschlag_rektorat) {
            this.aufschlagRektorat = this.aufschlag_rektorat * 100;
        }

        if (this.rabatt_mitarbeiter) {
            this.rabattMitarbeiter = this.rabatt_mitarbeiter * 100;
        }
    }
}
